import { render } from "./GeneralValueInput.vue?vue&type=template&id=30c08cb6"
import script from "./GeneralValueInput.vue?vue&type=script&lang=js"
export * from "./GeneralValueInput.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__